import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  useDisclosure,
  Textarea,
  Tooltip,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Link,
  useBreakpointValue,
} from "@chakra-ui/react";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { MdSettingsBackupRestore } from "react-icons/md";

import { Link as ReactLink } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";

import { useLocation, useParams } from "react-router";
import Swal from "sweetalert2";
import {
  Permission,
  criancaFunc,
  situacaoJuridica,
} from "../../../../../../helpers/Funcionalidades";
import CriancaService from "../../../../../../main/services/CriancaService";
import { CustomButton } from "../../../../../components/CustomButton";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import SemRegistros from "../../../../../components/SemRegistros";
import { IrmaoTable } from "../../../ReferenciaFamiliar/Irmaos/Table";
import Group from "../../../../ServicosAcolhimento/Visualizar/Group";

import { SituacaoJuridicaModal } from "../Cadastrar/SituacaoJuridicaModal";
import { EntregaVoluntariaModal } from "../../EntregaVoluntaria/Cadastrar/EntregaVoluntariaModal";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { EditarSituacaoAdocaoModal } from "../../SituacaoAdocao/Editar";
import { IoHelpCircle } from "react-icons/io5";
import EditarPromotoriaModal from "../../AtribuicaoCompetencia/EditarPromotoriaModal";
import EditarVaraInfanciaModal from "../../AtribuicaoCompetencia/EditarVaraInfanciaModal";
import { VisualizarJustificativaModal } from "../../AtribuicaoCompetencia/VisualizarJustificativaModal";
import { useAuthProvider } from "../../../../../../Context/AuthProvider";
import { scrollToFieldAnexo } from "../../../../../utils/scrollToFIeldAnexo";
import { useHistory } from "react-router-dom";
import { deleteUrlParam } from "../../../../../utils/deleteUrlParam";
import { PopoverGenero } from "../../../../../components/PopoverGenero";

export const SituacoesJuridicas = ({ setLoadingPainel }) => {
  const {
    isOpen: isOpenCadastrarProcessos,
    onOpen: onOpenCadastrarProcessos,
    onClose: onCloseCadastrarProcessos,
  } = useDisclosure();
  const {
    isOpen: isOpenCadastrarEntrega,
    onOpen: onOpenCadastrarEntrega,
    onClose: onCloseCadastrarEntrega,
  } = useDisclosure();

  const {
    isOpen: isOpenEditarAdocao,
    onOpen: onOpenEditarAdocao,
    onClose: onCloseEditarAdocao,
  } = useDisclosure();

  const {
    isOpen: isOpenEditarPromotoria,
    onOpen: onOpenEditarPromotoria,
    onClose: onCloseEditarPromotoria,
  } = useDisclosure();

  const {
    isOpen: isOpenEditarVaraInfancia,
    onOpen: onOpenEditarVaraInfancia,
    onClose: onCloseEditarVaraInfancia,
  } = useDisclosure();

  const {
    isOpen: isOpenVisualizarDefinicao,
    onOpen: onOpenVisualizarDefinicao,
    onClose: onCloseVisualizarDefinicao,
  } = useDisclosure();

  const { id } = useParams();
  const [data, setData] = useState([]);
  const [definicao, setDefinicao] = useState("");
  const [dataAdocao, setDataAdocao] = useState();
  const [dataVoluntariaCadastrar, setDataVoluntariaCadastrar] = useState([]);
  const [dataProcedimentos, setDataProcedimentos] = useState([]);
  const [dataVoluntaria, setDataVoluntaria] = useState([]);
  const { houveExtincaoPoderFamiliar } = useAppContext();
  const [loadingATB, setLoadingATB] = useState(false);
  const [loadingPP, setLoadingPP] = useState(false);
  const placement = useBreakpointValue({ md: "right" });
  const [isSelectedPromotoria, setIsSelectedPromotoria] = useState();

  const [isSelectedVara, setIsSelectedVara] = useState();

  const [buttonText, setButtonText] = useState("");

  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  const history = useHistory();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idTipoPendencia = searchParams.get("idTipoPendencia");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintProcesso, setHintProcesso] = useState(false);
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const [hintProcedimento, setHintProcedimento] = useState(false);
  const [hintRequisitos, setHintRequisitos] = useState(false);

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo || idTipoPendencia, ref);
    },
    [idAnexo, idTipoPendencia]
  );

  const showMenuItemsAtribuicao =
    roleKeycloack.includes(situacaoJuridica.promotoriaEditar) ||
    roleKeycloack.includes(situacaoJuridica.promotoriaEditarConcorrente) ||
    roleKeycloack.includes(situacaoJuridica.varaEditar) ||
    roleKeycloack.includes(situacaoJuridica.promotoriaReativar) ||
    roleKeycloack.includes(situacaoJuridica.varaReativar);
  const columnsProcessos = [
    {
      Header: "Nº do Processo",
      accessor: "numeroProcesso",
      Cell: (props) => {
        const irmaosProcesso = props.row.original.irmaos || [];

        const formatarNomes = (nomes) => {
          if (nomes.length === 0) return "";
          if (nomes.length === 1) return nomes[0];
          if (nomes.length === 2) return `${nomes[0]} e ${nomes[1]}`;
          const todosMenosUltimo = nomes.slice(0, -1).join(", ");
          const ultimo = nomes[nomes.length - 1];
          return `${todosMenosUltimo} e ${ultimo}`;
        };

        const nomesIrmaos = irmaosProcesso
          .filter((irmao) => irmao.compartilhado === "S")
          .map((irmao) => irmao.nomeIrmao);
        const textoTooltip = nomesIrmaos.length
          ? ` ${formatarNomes(nomesIrmaos)}.`
          : "";

        return (
          <Flex>
            <Text whiteSpace={"nowrap"} title={props.value}>
              {props.value}
            </Text>
            {nomesIrmaos && nomesIrmaos.length > 0 && (
              <>
                {isMobile ? (
                  <PopoverGenero
                    isOpen={hintProcesso}
                    setIsOpen={setHintProcesso}
                    flex={true}
                    handleClick={() => setHintProcesso(!hintProcesso)}
                    labelTextoGenero={`Processo compartilhado com o(s) irmão(s): ${textoTooltip}`}
                  />
                ) : (
                  <Tooltip
                    label={`Processo compartilhado com o(s) irmão(s): ${textoTooltip}`}
                    fontSize="md"
                    textAlign={"justify"}
                    placement={placement}
                    maxWidth={"400px"}
                  >
                    <span className="hint-tooltip">
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#6B6C71"
                        as={IoHelpCircle}
                        boxSize={{ base: "20px" }}
                      />
                    </span>
                  </Tooltip>
                )}
              </>
            )}
          </Flex>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text whiteSpace={"normal"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Sentença",
      accessor: "sentenca",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
    {
      Header: "Tipo de Sentença",
      accessor: "descricaoTipoSentenca",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Trânsito julgado",
      accessor: "transitoJulgado",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
  ];

  const columnsProcedimentos = [
    {
      Header: "Nº do Procedimento",
      accessor: "numeroProcesso",
      Cell: (props) => {
        const irmaosProcedimento = props.row.original.irmaos || [];

        const formatarNomes = (nomes) => {
          if (nomes.length === 0) return "";
          if (nomes.length === 1) return nomes[0];
          if (nomes.length === 2) return `${nomes[0]} e ${nomes[1]}`;
          const todosMenosUltimo = nomes.slice(0, -1).join(", ");
          const ultimo = nomes[nomes.length - 1];
          return `${todosMenosUltimo} e ${ultimo}`;
        };

        const nomesIrmaos = irmaosProcedimento
          .filter((irmao) => irmao.compartilhado === "S")
          .map((irmao) => irmao.nomeIrmao);
        const textoTooltip = nomesIrmaos.length
          ? `${formatarNomes(nomesIrmaos)}.`
          : "";

        return (
          <Flex>
            <Text display="flex" whiteSpace={"nowrap"} title={props.value}>
              {props.value}
            </Text>
            {nomesIrmaos && nomesIrmaos.length > 0 && (
              <>
                {isMobile ? (
                  <PopoverGenero
                    isOpen={hintProcedimento}
                    setIsOpen={setHintProcedimento}
                    flex={true}
                    handleClick={() => setHintProcedimento(!hintProcedimento)}
                    labelTextoGenero={`Procedimento compartilhado com o(s) irmão(s): ${textoTooltip}`}
                  />
                ) : (
                  <Tooltip
                    label={`Procedimento compartilhado com o(s) irmão(s): ${textoTooltip}`}
                    fontSize="md"
                    textAlign={"justify"}
                    maxWidth={"400px"}
                    placement={placement}
                  >
                    <span className="hint-tooltip">
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#6B6C71"
                        as={IoHelpCircle}
                        boxSize={{ base: "20px" }}
                      />
                    </span>
                  </Tooltip>
                )}
              </>
            )}
          </Flex>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text whiteSpace={"normal"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Sentença",
      accessor: "sentenca",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
    {
      Header: "Tipo de Sentença",
      accessor: "descricaoTipoSentenca",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Trânsito julgado",
      accessor: "transitoJulgado",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
  ];

  const columnsEntregaVisualizar = [
    {
      Header: "Houve Extinção do Poder Familiar?",
      accessor: "extincaoPoderFamilia",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : props.value === "A"
              ? "Aguardando Prazo"
              : ""}
          </span>
        );
      },
      disableSortBy: true,
    },
    {
      Header: (props) => {
        return (
          <span title={props.column.id}>{`Nº do ${
            props?.data[0]?.tipoSituacaoJuridica === "P"
              ? "Processo"
              : "Procedimento"
          }`}</span>
        );
      },
      accessor: "numeroProcesso",
      Cell: (props) => {
        return (
          <Text whiteSpace={"nowrap"} title={props.value}>
            {props.value}{" "}
          </Text>
        );
      },
      disableSortBy: true,
    },

    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
      disableSortBy: true,
    },
  ];

  const columnsEntregaCadastrar = [
    {
      Header: "Nº do Processo/Procedimento",
      accessor: "numeroProcesso",
      Cell: (props) => {
        return (
          <Flex alignItems="center" gap={2} whiteSpace={"nowrap"}>
            <RadioButtonField
              fieldName={"idProcessoProcedimento"}
              value={`${props.row.original.id}`}
              label=""
            />

            <span title={props.value}>{props.value}</span>
          </Flex>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
    },
  ];

  const AlertaMessage = () => {
    Swal.fire({
      title: "Atenção!",
      text: "Cadastre um processo ou procedimento.",
      icon: "warning",
      confirmButtonText: "Fechar",
      confirmButtonColor: "#169499",
    }).then((result) => {});
  };

  const columnsPromotoriaModal = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Município",
      accessor: "municipios",
      Cell: (props) => {
        const values = props.value;
        return values.map((municipio, index) => {
          return (
            <React.Fragment key={index}>
              <span>{municipio.nome}</span>
              {values.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
  ];

  const columnsVaraInfanciaModal = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Comarca",
      accessor: "comarca",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
  ];

  const fetchAdocaoData = useCallback(() => {
    setLoadingPP(true);
    CriancaService.getAdocao(id)
      .then((res) => {
        setDataAdocao(res.data);
        setLoadingPP(false);
      })
      .catch((error) => {
        console.log("Error no getVisita", error);
        setLoadingPP(false);
      });
  }, [id]);

  const fetchEntregaVoluntaria = useCallback(() => {
    setLoadingPP(true);
    CriancaService.getEntregaVoluntaria(id)
      .then((res) => {
        if (res.data) {
          setDataVoluntaria([res.data]);
        } else {
          setDataVoluntaria([]);
        }
        setLoadingPP(false);
        fetchAdocaoData();
      })
      .catch((error) => {
        setDataVoluntaria([]);
        console.log("Error no getVisita", error);

        setLoadingPP(false);
      });
  }, [id, fetchAdocaoData]);

  const fetchProcessosProcedimentoData = useCallback(() => {
    setLoadingPP(true);
    setLoadingPainel(true);
    CriancaService.getProcessoProcedimento(id)
      .then((res) => {
        const dataFiltrada = res.data.filter(
          (item) => item.tipoSituacaoJuridica === "P"
        );
        setData(dataFiltrada);

        const dataProcedimentosFiltrada = res.data.filter(
          (item) => item.tipoSituacaoJuridica === "D"
        );
        setDataProcedimentos(dataProcedimentosFiltrada);

        setDataVoluntariaCadastrar(res.data);

        setLoadingPP(false);
        fetchEntregaVoluntaria();
        fetchAdocaoData();
      })
      .catch((error) => {
        console.log("Error no getVisita", error);
        setLoadingPP(false);
      });
  }, [id, fetchAdocaoData, setLoadingPainel, fetchEntregaVoluntaria]);

  const fetchAtribuicao = useCallback(() => {
    setLoadingATB(true);

    Promise.all([
      CriancaService.getAtribuicaoCompetenciaValidar(id),
      CriancaService.getAtribuicaoCompetencia(id),
      fetchProcessosProcedimentoData(),
    ])
      .then(([resValidar, res]) => {
        const promotoriaData = {
          id: res.data.idPromotoria || "",
          nome: res.data.nomePromotoria || "",
          justificativa: res.data.justificativaPromotoria || "",
          municipioPromotoria: res.data.municipioPromotoria || "",
          tipoAtribuicaoPromotoria: res.data.tipoAtribuicaoPromotoria || "",
          promotoriaConcorrente: res.data.concorrente || false,
          editarPromotoria: res.data.editarPromotoria || false,
        };

        const varaData = {
          id: res.data.idVara || "",
          nome: res.data.nomeVara || "",
          comarcaVara: res.data.comarcaVara || "",
          justificativa: res.data.justificativaVara || "",
          tipoAtribuicaoVara: res.data.tipoAtribuicaoVara || "",
        };

        if (!promotoriaData.id) {
          setIsSelectedPromotoria({
            id: resValidar.data.idPromotoria || "",
            nome: resValidar.data.nomePromotoria || "",
            justificativa: resValidar.data.justificativaPromotoria || "",
            municipioPromotoria: resValidar.data.municipioPromotoria || "",
            tipoAtribuicaoPromotoria:
              resValidar.data.tipoAtribuicaoPromotoria || "",
            promotoriaConcorrente: resValidar.data.concorrente || false,
            editarPromotoria: resValidar.data.editarPromotoria || false,
          });
        } else {
          setIsSelectedPromotoria(promotoriaData);
        }

        if (!varaData.id) {
          setIsSelectedVara({
            id: resValidar.data.idVara || "",
            nome: resValidar.data.nomeVara || "",
            comarcaVara: resValidar.data.comarcaVara || "",
            justificativa: resValidar.data.justificativaVara || "",
            tipoAtribuicaoVara: resValidar.data.tipoAtribuicaoVara || "",
          });
        } else {
          setIsSelectedVara(varaData);
        }
        setLoadingATB(false);
      })
      .catch((err) => {
        console.log("Erro no get de Atribuição e Competência", err);
        setLoadingATB(false);
      });
  }, [id, fetchProcessosProcedimentoData]);

  const deleteProcessoProcedimento = (
    idProcessoProcedimento,
    compartilhado,
    onClose
  ) => {
    Swal.fire({
      title: "Atenção",
      text:
        compartilhado === "S"
          ? "A exclusão de um processo/procedimento compartilhado excluirá as informações em todas as fichas envolvidas. Deseja prosseguir?"
          : "Todas as informações serão excluídas, deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteProcessoProcedimento(id, idProcessoProcedimento)
          .then((res) => {
            if (id) {
              CriancaService.getAtribuicaoCompetenciaAtualizar(id);
              Promise.all([fetchAtribuicao()]).then(() => {
                fetchProcessosProcedimentoData();
              });
            }
            deleteUrlParam("idAnexo", history);
            Swal.fire({
              title: "Sucesso!",
              text: "Sucesso! Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {
              if (result.isConfirmed) {
                onClose();
              }
            });
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              html: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  const deleteEntregaVoluntaria = (idProcessoProcedimento, onClose) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir a entrega voluntária?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteEntregaVoluntaria(id, idProcessoProcedimento)
          .then((res) => {
            fetchEntregaVoluntaria();
            fetchAdocaoData();

            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {
              if (result.isConfirmed) {
                onClose();
              }
            });
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error?.response?.data?.message
                ? error?.response?.data?.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  useEffect(() => {
    fetchProcessosProcedimentoData();
    fetchAdocaoData();
    fetchAtribuicao();
    fetchEntregaVoluntaria();
  }, [
    fetchProcessosProcedimentoData,
    fetchAdocaoData,
    fetchAtribuicao,
    fetchEntregaVoluntaria,
  ]);

  const backAlertReativarPromotoria = (tipo) => {
    Swal.fire({
      title: "Atenção",
      text: "Ao reativar para definição automática, todas as justificativas inseridas na definição manual serão excluídas. Deseja prosseguir?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoadingATB(true);
        if (tipo === "promotoria") {
          CriancaService.reativarPromotoriaJuridica(id)
            .then(() => {
              Swal.fire({
                title: "Sucesso!",
                text: "Reativação automática realizada com sucesso.",
                icon: "success",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#169499",
              }).then((result) => {});
              Promise.all([fetchAtribuicao()]).finally(() =>
                setLoadingATB(false)
              );
            })
            .catch((error) => {
              console.log(error.response.data);

              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
              setLoadingATB(false);
            });
        } else {
          CriancaService.reativarVaraInfancia(id)
            .then(() => {
              Swal.fire({
                title: "Sucesso!",
                text: "Reativação automática realizada com sucesso.",
                icon: "success",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#169499",
              }).then((result) => {});
              Promise.all([fetchAtribuicao()]).finally(() =>
                setLoadingATB(false)
              );
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
              setLoadingATB(false);
            });
        }
      }
    });
  };

  const menuComponent = (
    <Box
      position={{ base: "relative", md: "absolute" }}
      top={{ md: "38px" }}
      left={{ base: "20%", md: "50%" }}
      transform={{ md: "translateX(-50%)" }}
      zIndex={2}
    >
      <Menu>
        <MenuButton
          as={IconButton}
          icon={<BsThreeDots color="#fff" fontSize="20px" />}
          variant={"link"}
          cursor={"pointer"}
          backgroundColor="#95BCBF"
          rounded={100}
          p={2}
        />

        <MenuList width="min-content" minWidth="240px">
          {(roleKeycloack.includes(situacaoJuridica.promotoriaEditar) ||
            roleKeycloack.includes(
              situacaoJuridica.promotoriaEditarConcorrente
            )) && (
            <MenuItem
              p={2}
              color={"#374BCE"}
              onClick={() => onOpenEditarPromotoria()}
            >
              <FiEdit />
              <Text ml="5px" fontSize={"md"}>
                Editar Promotoria de Justiça
              </Text>
            </MenuItem>
          )}

          <Permission
            roleKeycloack={roleKeycloack}
            func={situacaoJuridica.varaEditar}
          >
            <MenuItem
              p={2}
              color={"#374BCE"}
              onClick={() => onOpenEditarVaraInfancia()}
            >
              <FiEdit />
              <Text ml="5px" fontSize={"md"}>
                Editar Vara da Infância
              </Text>
            </MenuItem>
          </Permission>

          {isSelectedPromotoria?.tipoAtribuicaoPromotoria === "M" && (
            <Permission
              roleKeycloack={roleKeycloack}
              func={situacaoJuridica.promotoriaReativar}
            >
              <MenuItem
                p={2}
                color={"#374BCE"}
                onClick={() => backAlertReativarPromotoria("promotoria")}
              >
                <Box w={"16px"}>
                  <MdSettingsBackupRestore size={17} />
                </Box>
                <Text ml="5px" fontSize={"md"}>
                  Reativar Definição Automática (Promotoria de Justiça)
                </Text>
              </MenuItem>
            </Permission>
          )}

          {isSelectedVara?.tipoAtribuicaoVara === "M" && (
            <Permission
              roleKeycloack={roleKeycloack}
              func={situacaoJuridica.varaReativar}
            >
              <MenuItem
                p={2}
                color={"#374BCE"}
                onClick={() => backAlertReativarPromotoria("vara")}
              >
                <Box w={"16px"}>
                  <MdSettingsBackupRestore size={17} />
                </Box>
                <Text ml="5px" fontSize={"md"}>
                  Reativar Definição Automática (Vara da Infância)
                </Text>
              </MenuItem>
            </Permission>
          )}
        </MenuList>
      </Menu>
    </Box>
  );

  const renderizarHintProcesso = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Procedimento de Acolhimento e outros sem garantia aos pais ou responsável legal do exercício do contraditório e ampla defesa, não são considerados como processos judiciais pelo MCA e sim procedimentos, tendo em vista o disposto no art. 101, § 2º do ECA e no art. 14 da Resolução nº 293/24 do CNMP."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Procedimento de Acolhimento e outros sem garantia aos pais ou responsável legal do exercício do contraditório e ampla defesa, não são considerados como processos judiciais pelo MCA e sim procedimentos, tendo em vista o disposto no art. 101, § 2º do ECA e no art. 14 da Resolução nº 293/24 do CNMP."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      {roleKeycloack &&
      (roleKeycloack?.includes(criancaFunc.visualizarJuridica) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ))) ? (
        <>
          {!loadingATB ? (
            <Group
              title="Atribuição e Competência"
              minHeight={"118px"}
              menuComponent={menuComponent}
              showMenuItemsAtribuicao={showMenuItemsAtribuicao}
              opcoes={
                roleKeycloack.includes(
                  situacaoJuridica.promotoriaEditarConcorrente
                ) && !isSelectedPromotoria?.editarPromotoria
                  ? false
                  : true
              }
            >
              <>
                <Flex mt={4} alignItems="center" gap={8}>
                  <Text as="b">Promotoria de Justiça com Atribuição:</Text>
                  {roleKeycloack &&
                  roleKeycloack?.includes(
                    situacaoJuridica.promotoriaJustificativa
                  ) &&
                  isSelectedPromotoria?.tipoAtribuicaoPromotoria === "M" ? (
                    <Link
                      wordBreak={"break-all"}
                      title={`${
                        isSelectedPromotoria?.tipoAtribuicaoPromotoria === "A"
                          ? "Definição Automática"
                          : "Definição Manual"
                      } `}
                      as={ReactLink}
                      to="#"
                      color="#169499"
                      _focus={{ boxShadow: "none" }}
                      onClick={() => {
                        onOpenVisualizarDefinicao();
                        setDefinicao("promotoria");
                      }}
                    >
                      <Text whiteSpace="nowrap" color="#169499">{`${
                        isSelectedPromotoria?.tipoAtribuicaoPromotoria === "A"
                          ? "Definição Automática"
                          : isSelectedPromotoria?.tipoAtribuicaoPromotoria ===
                            "M"
                          ? "Definição Manual"
                          : ""
                      } `}</Text>
                    </Link>
                  ) : (
                    <Text whiteSpace="nowrap" color="#169499">{`${
                      isSelectedPromotoria?.tipoAtribuicaoPromotoria === "A"
                        ? "Definição Automática"
                        : isSelectedPromotoria?.tipoAtribuicaoPromotoria === "M"
                        ? "Definição Manual"
                        : ""
                    } `}</Text>
                  )}
                </Flex>
                <Text mt={2}>{isSelectedPromotoria?.nome}</Text>
                <Flex mt={6} alignItems="center" gap={8}>
                  <Text as="b">Vara da Infância Competente:</Text>
                  {roleKeycloack &&
                  roleKeycloack?.includes(situacaoJuridica.varaJustificativa) &&
                  isSelectedVara?.tipoAtribuicaoVara === "M" ? (
                    <Link
                      wordBreak={"break-all"}
                      title={`${
                        isSelectedVara?.tipoAtribuicaoVara === "A"
                          ? "Definição Automática"
                          : "Definição Manual"
                      } `}
                      as={ReactLink}
                      to="#"
                      _focus={{ boxShadow: "none" }}
                      color="#169499"
                      onClick={() => {
                        onOpenVisualizarDefinicao();
                        setDefinicao("vara");
                      }}
                    >
                      <Text whiteSpace="nowrap" color="#169499">{`${
                        isSelectedVara.tipoAtribuicaoVara === "A"
                          ? "Definição Automática"
                          : isSelectedVara.tipoAtribuicaoVara === "M"
                          ? "Definição Manual"
                          : ""
                      } `}</Text>
                    </Link>
                  ) : (
                    <Text whiteSpace="nowrap" color="#169499">{`${
                      isSelectedVara?.tipoAtribuicaoVara === "A"
                        ? "Definição Automática"
                        : isSelectedVara?.tipoAtribuicaoVara === "M"
                        ? "Definição Manual"
                        : ""
                    } `}</Text>
                  )}
                </Flex>
                <Text mt={2}>{isSelectedVara?.nome}</Text>

                <EditarPromotoriaModal
                  dataVoluntaria={[isSelectedPromotoria]}
                  roleKeycloack={roleKeycloack}
                  isOpen={isOpenEditarPromotoria}
                  onOpen={onOpenEditarPromotoria}
                  onClose={onCloseEditarPromotoria}
                  idCrianca={id}
                  columnsPromotoriaModal={columnsPromotoriaModal}
                  fetchAtribuicao={fetchAtribuicao}
                />

                <EditarVaraInfanciaModal
                  dataVoluntaria={[isSelectedVara]}
                  isOpen={isOpenEditarVaraInfancia}
                  onOpen={onOpenEditarVaraInfancia}
                  onClose={onCloseEditarVaraInfancia}
                  idCrianca={id}
                  columnsVaraInfanciaModal={columnsVaraInfanciaModal}
                  fetchAtribuicao={fetchAtribuicao}
                />

                <VisualizarJustificativaModal
                  isOpen={isOpenVisualizarDefinicao}
                  onOpen={onOpenVisualizarDefinicao}
                  selected={
                    definicao === "promotoria"
                      ? isSelectedPromotoria
                      : isSelectedVara
                  }
                  idCrianca={id}
                  definicao={definicao}
                  onClose={() => {
                    onCloseVisualizarDefinicao();
                  }}
                  roleKeycloack={roleKeycloack}
                  fetchProcessosProcedimentoData={
                    fetchProcessosProcedimentoData
                  }
                  fetchAdocaoData={fetchAdocaoData}
                  fetchAtribuicao={fetchAtribuicao}
                />
              </>
            </Group>
          ) : (
            <Box mt="2">
              <LoadingSpinner />
            </Box>
          )}

          {!loadingPP ? (
            <>
              {(data && data.length > 0) ||
              (dataProcedimentos && dataProcedimentos.length > 0) ? (
                <>
                  <Group
                    title={
                      <Flex>
                        <Text textTransform="uppercase">
                          Processos e Procedimentos
                        </Text>

                        {renderizarHintProcesso()}
                      </Flex>
                    }
                    border={
                      ["13", "14", "15", "16", "17"].includes(idAnexo) ||
                      ["46", "47"].includes(idTipoPendencia)
                        ? "3px solid #4299E199"
                        : ""
                    }
                    scrollToField={
                      ["13", "14", "15", "16", "17"].includes(idAnexo) ||
                      ["46", "47"].includes(idTipoPendencia)
                        ? scrollToField
                        : null
                    }
                  >
                    <SimpleGrid
                      mt="30px"
                      columns={{ base: 1, md: 5 }}
                      spacing="20px"
                      marginTop={{ base: "10px", md: "-50px" }}
                      dir="rtl"
                    >
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={criancaFunc.cadastrarPP}
                      >
                        <CustomButton
                          width={{ base: "50%", md: "auto" }}
                          label="Cadastrar"
                          isDisabled={false}
                          buttonBlocked={true}
                          onClick={() => {
                            onOpenCadastrarProcessos();
                          }}
                        />
                      </Permission>
                      <SituacaoJuridicaModal
                        isOpen={isOpenCadastrarProcessos}
                        onOpen={onOpenCadastrarProcessos}
                        idCrianca={id}
                        onClose={() => {
                          onCloseCadastrarProcessos();
                        }}
                        roleKeycloack={roleKeycloack}
                        fetchProcessosProcedimentoData={
                          fetchProcessosProcedimentoData
                        }
                        fetchAtribuicao={fetchAtribuicao}
                      />
                    </SimpleGrid>
                    {data && data.length > 0 && (
                      <Box
                        mt={
                          roleKeycloack?.includes(criancaFunc.cadastrarPP)
                            ? 4
                            : 16
                        }
                      >
                        <Box py="1" px={6} bgColor={"#DDEBEA"}>
                          <Text fontWeight={"700"} color={"gray.600"}>
                            Processos
                          </Text>
                        </Box>
                        <IrmaoTable
                          mt={"0px"}
                          columns={columnsProcessos}
                          data={data}
                          filiacoes={data}
                          entidade="processos"
                          processos={true}
                          deleteProcessoProcedimento={
                            deleteProcessoProcedimento
                          }
                          idCrianca={id}
                          fetchProcessosProcedimentoData={
                            fetchProcessosProcedimentoData
                          }
                          fetchAtribuicao={fetchAtribuicao}
                        />
                      </Box>
                    )}

                    {dataProcedimentos && dataProcedimentos.length > 0 && (
                      <Box
                        mt={
                          roleKeycloack?.includes(criancaFunc.cadastrarPP)
                            ? 4
                            : 16
                        }
                      >
                        <Box py="1" px={6} bgColor={"#DDEBEA"}>
                          <Text fontWeight={"700"} color={"gray.600"}>
                            Procedimentos
                          </Text>
                        </Box>
                        <IrmaoTable
                          mt={"0px"}
                          columns={columnsProcedimentos}
                          data={dataProcedimentos}
                          filiacoes={dataProcedimentos}
                          entidade="procedimentos"
                          procedimentos={true}
                          deleteProcessoProcedimento={
                            deleteProcessoProcedimento
                          }
                          idCrianca={id}
                          fetchProcessosProcedimentoData={
                            fetchProcessosProcedimentoData
                          }
                          fetchAtribuicao={fetchAtribuicao}
                        />
                      </Box>
                    )}
                  </Group>
                </>
              ) : (
                <Group
                  title={
                    <Flex>
                      <Text textTransform="uppercase">
                        Processos e Procedimentos
                      </Text>

                      {renderizarHintProcesso()}
                    </Flex>
                  }
                  border={
                    ["13", "14", "15", "16", "17"].includes(idAnexo) ||
                    ["46", "47"].includes(idTipoPendencia)
                      ? "3px solid #4299E199"
                      : ""
                  }
                  scrollToField={
                    ["13", "14", "15", "16", "17"].includes(idAnexo) ||
                    ["46", "47"].includes(idTipoPendencia)
                      ? scrollToField
                      : null
                  }
                >
                  <SimpleGrid
                    mt="30px"
                    columns={{ base: 1, md: 5 }}
                    spacing="20px"
                    marginTop={{ base: "10px", md: "-50px" }}
                    dir="rtl"
                  >
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.cadastrarPP}
                    >
                      <CustomButton
                        width={{ base: "50%", md: "auto" }}
                        label="Cadastrar"
                        isDisabled={false}
                        buttonBlocked={true}
                        onClick={() => {
                          onOpenCadastrarProcessos();
                        }}
                      />
                    </Permission>
                    <SituacaoJuridicaModal
                      isOpen={isOpenCadastrarProcessos}
                      onOpen={onOpenCadastrarProcessos}
                      idCrianca={id}
                      onClose={() => {
                        onCloseCadastrarProcessos();
                      }}
                      roleKeycloack={roleKeycloack}
                      fetchProcessosProcedimentoData={
                        fetchProcessosProcedimentoData
                      }
                      fetchAtribuicao={fetchAtribuicao}
                    />
                  </SimpleGrid>
                  <Box
                    mt={
                      roleKeycloack?.includes(criancaFunc.cadastrarPP) ? 2 : 20
                    }
                  >
                    <SemRegistros half buttonVisible={true} />
                  </Box>
                </Group>
              )}
            </>
          ) : (
            <Box mt="2">
              <LoadingSpinner />
            </Box>
          )}

          {houveExtincaoPoderFamiliar && (
            <Group
              title="Entrega Voluntária"
              border={idTipoPendencia === "48" ? "3px solid #4299E199" : ""}
              scrollToField={idTipoPendencia === "48" ? scrollToField : null}
              minHeight={"118px"}
              entrega={true}
            >
              <SimpleGrid
                mt="30px"
                columns={{ base: 1, md: 5 }}
                spacing="20px"
                marginTop={{
                  base: "10px",
                  md:
                    dataVoluntaria && dataVoluntaria.length === 0
                      ? "-50px"
                      : "0px",
                }}
                dir="rtl"
              >
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={criancaFunc.cadastrarVoluntaria}
                >
                  {dataVoluntaria && dataVoluntaria.length === 0 && (
                    <CustomButton
                      width={{ base: "50%", md: "auto" }}
                      label={"Cadastrar"}
                      buttonBlocked={true}
                      onClick={() => {
                        dataVoluntaria && dataVoluntaria.length > 0
                          ? setButtonText("Editar")
                          : setButtonText("Cadastrar");

                        if (
                          (data && data.length > 0) ||
                          (dataProcedimentos && dataProcedimentos.length > 0)
                        ) {
                          onOpenCadastrarEntrega();
                        } else {
                          AlertaMessage();
                        }
                      }}
                    />
                  )}
                </Permission>
                <EntregaVoluntariaModal
                  isOpen={isOpenCadastrarEntrega}
                  onOpen={onOpenCadastrarEntrega}
                  idCrianca={id}
                  dataVoluntaria={dataVoluntaria}
                  data={dataVoluntariaCadastrar}
                  columnsEntregaCadastrar={columnsEntregaCadastrar}
                  alerta={
                    data &&
                    data.length <= 0 &&
                    dataProcedimentos &&
                    dataProcedimentos.length <= 0
                  }
                  onClose={() => {
                    onCloseCadastrarEntrega();
                  }}
                  buttonText={buttonText}
                  roleKeycloack={roleKeycloack}
                  fetchEntregaVoluntaria={fetchEntregaVoluntaria}
                />
              </SimpleGrid>
              {!loadingPP ? (
                <>
                  {dataVoluntaria && dataVoluntaria.length > 0 ? (
                    <Box mt={4}>
                      <>
                        <Box py="1" px={6} mt={6} bgColor={"#DDEBEA"}>
                          <Text fontWeight={"700"} color={"gray.600"}>
                            Processos/Procedimentos
                          </Text>
                        </Box>
                        <IrmaoTable
                          disableHeaderOptionsPagination={true}
                          mt={"0px"}
                          roleKeycloack={roleKeycloack}
                          columns={columnsEntregaVisualizar}
                          data={dataVoluntaria}
                          entidade={"entrega"}
                          entrega={true}
                          filiacoes={dataVoluntaria}
                          fetchProcessosProcedimentoData={
                            fetchProcessosProcedimentoData
                          }
                          deleteProcessoProcedimento={
                            deleteProcessoProcedimento
                          }
                          fetchEntregaVoluntaria={fetchEntregaVoluntaria}
                          fetchAtribuicao={fetchAtribuicao}
                          deleteEntregaVoluntaria={deleteEntregaVoluntaria}
                          idCrianca={id}
                          dataVoluntariaCadastrar={dataVoluntariaCadastrar}
                        />
                      </>
                    </Box>
                  ) : (
                    <Box
                      mt={
                        roleKeycloack?.includes(criancaFunc.editarVoluntaria) ||
                        roleKeycloack?.includes(criancaFunc.cadastrarVoluntaria)
                          ? 6
                          : 16
                      }
                    >
                      <Text as="b">Houve Extinção do Poder Familiar?</Text>
                    </Box>
                  )}
                </>
              ) : (
                <Box mt="2">
                  <LoadingSpinner />
                </Box>
              )}
            </Group>
          )}

          <Group title="Situação quanto à adoção" minHeight={"118px"}>
            <SimpleGrid
              mt="30px"
              columns={{ base: 1, md: 5 }}
              spacing="20px"
              marginTop={{ base: "10px", md: "-50px" }}
              dir="rtl"
            >
              <Permission
                roleKeycloack={roleKeycloack}
                func={criancaFunc.editarAdocao}
              >
                <CustomButton
                  width={{ base: "50%", md: "auto" }}
                  label="Editar"
                  buttonBlocked={true}
                  onClick={() => {
                    onOpenEditarAdocao();
                  }}
                />
              </Permission>
              <EditarSituacaoAdocaoModal
                isOpen={isOpenEditarAdocao}
                onOpen={onOpenEditarAdocao}
                dataAdocao={dataAdocao}
                idCrianca={id}
                onClose={() => {
                  onCloseEditarAdocao();
                }}
                roleKeycloack={roleKeycloack}
                fetchProcessosProcedimentoData={fetchProcessosProcedimentoData}
                fetchAdocaoData={fetchAdocaoData}
              />
            </SimpleGrid>
            <Flex
              alignItems="center"
              gap={2}
              mt={roleKeycloack?.includes(criancaFunc.editarAdocao) ? 6 : 16}
            >
              <Text as="b">Cumpre Requisitos para Adoção? </Text>
              {isMobile ? (
                <PopoverGenero
                  isOpen={hintRequisitos}
                  setIsOpen={setHintRequisitos}
                  flex={true}
                  handleClick={() => setHintRequisitos(!hintRequisitos)}
                  labelTextoGenero={
                    "O sistema MCA considera critérios objetivos definidos pelo Sistema Nacional de Adoção (SNA) para estabelecer de forma automatizada a condição quanto à adoção. Atualmente, não existe uma integração entre MCA e SNA"
                  }
                />
              ) : (
                <Tooltip
                  textAlign={"justify"}
                  label={
                    "O sistema MCA considera critérios objetivos definidos pelo Sistema Nacional de Adoção (SNA) para estabelecer de forma automatizada a condição quanto à adoção. Atualmente, não existe uma integração entre MCA e SNA"
                  }
                >
                  <Box h={"20px"}>
                    <Icon
                      aria-label="Aviso de pendente"
                      color="#6B6C71"
                      as={IoHelpCircle}
                      boxSize="20px"
                    />
                  </Box>
                </Tooltip>
              )}
            </Flex>
            <Text textAlign="justify" mt={2}>
              {dataAdocao?.cumpreRequisitoAdocao === "S" ? "Sim" : "Não"}
              {dataAdocao?.motivoAptoAdocao?.descricao
                ? ` - ${dataAdocao?.motivoAptoAdocao?.descricao}`
                : ""}
            </Text>
            <Box mt={2}>
              <Text as="b">Observações: </Text>

              <Flex flexDir="column" position="relative">
                <Textarea
                  mt={2}
                  defaultValue={`${
                    dataAdocao?.observacao ? dataAdocao?.observacao : ""
                  }`}
                  name="observacao"
                  id="observacao"
                  backgroundColor="#fff"
                  autoComplete="off"
                  disabled={true}
                  sx={{
                    "&:disabled": {
                      backgroundColor: "inherit",
                      borderColor: "inherit",
                      "&:hover": {
                        borderColor: "inherit",
                      },
                    },
                  }}
                  placeholder="Informe as Observações"
                  maxLength={255}
                />
                <Text
                  zIndex={0}
                  fontSize="sm"
                  position="absolute"
                  bottom="5px"
                  right="15px"
                  color={
                    dataAdocao?.observacao &&
                    dataAdocao?.observacao.length === 255
                      ? "red"
                      : "gray"
                  }
                >
                  {dataAdocao?.observacao
                    ? `${dataAdocao?.observacao.length}/255`
                    : "0/255"}
                </Text>
              </Flex>
            </Box>
          </Group>
        </>
      ) : (
        <Box mt="2">
          <SemRegistros buttonVisible={true} />
        </Box>
      )}
    </>
  );
};
